import { cpf, cnpj } from 'cpf-cnpj-validator'

export function validateCPF(value: string): boolean {
  return cpf.isValid(value)
}

export function validateCNPJ(value: string): boolean {
  return cnpj.isValid(value)
}
